export const validatePassword = (_: any, value: any) => {
  if (!value) {
    return Promise.reject('请输入密码');
  }
  if (value.length < 6) {
    return Promise.reject('密码长度不能小于6位');
  }
  return Promise.resolve();
};

export const validateIdCard = (_: any, value: any) => {
  // if (!value) {
  //   return Promise.reject('请输入身份证号');
  // }
  // // 简单身份证验证（实际项目中应使用更严格的验证）
  // const idNumberPattern =
  //   /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;
  // if (!idNumberPattern.test(value)) {
  //   return Promise.reject('请输入正确的身份证号');
  // }
  return Promise.resolve();
};
